export const adminBlocks = {
  Audits: () => import(/* webpackChunkName: "WebAdminAudits" */ "./audits"),
  DialerStats: () => import(/* webpackChunkName: "WebAdminDialerStats" */ "./dialer-stats"),
  DialerStatsShow: () => import(/* webpackChunkName: "WebAdminDialerStatsShow" */ "./dialer-stats-show"),
  CreditCardLogs: () => import(/* webpackChunkName: "WebAdminCreditCardLogs" */ "./credit-card-logs"),
  MediaServers: () => import(/* webpackChunkName: "WebAdminMediaServers" */ "./media-servers"),
  MediaServersNew: () => import(/* webpackChunkName: "WebAdminMediaServersNew" */ "./media-servers-new"),
  KamailioGatewaysNew: () => import(/* webpackChunkName: "WebAdminKamailioGatewaysNew" */ "./kamailio-gateways-new"),
  Users: () => import(/* webpackChunkName: "WebAdminUsers" */ "./users"),
  ServiceNotifications: () => import(/* webpackChunkName: "WebAdminServiceNotifications" */ "./service-notifications"),
  Callcenters: () => import(/* webpackChunkName: "WebAdminCallcenters" */ "./callcenters"),
  StatusLogs: () => import(/* webpackChunkName: "WebAdminStatusLogs" */ "./status-logs"),
  IncomingNumbersPrices: () =>
    import(/* webpackChunkName: "WebAdminIncomingNumbersPrices" */ "./incoming-numbers-prices"),
  PrefixPriceOverrides: () => import(/* webpackChunkName: "WebAdminPrefixPriceOverrides" */ "./prefix-price-overrides"),
  Transactions: () => import(/* webpackChunkName: "WebAdminTransactions" */ "./transactions"),
  CallPriceOverrides: () => import(/* webpackChunkName: "WebAdminCallPriceOverrides" */ "./call-price-overrides")
}
